import {Component, Input, OnInit} from '@angular/core';
import {DevexTesterDataService} from "../../devex-tester-data.service";

@Component({
  selector: 'app-body-params-description',
  templateUrl: './body-params-description.component.html',
  styleUrls: ['./body-params-description.component.scss']
})
export class BodyParamsDescriptionComponent implements OnInit {

  @Input() bodyParams = [];
  @Input() rawBody: any;
  showTable = true;
  @Input() showImport = true;
  constructor(public devexTesterDataService: DevexTesterDataService) { }

  ngOnInit() {
  }
  addAttributeField(data) {
    const newData = {
      key: '',
      type: null,
      req: false,
      array: false,
      description: '',
      value: null
    };
    if (!data) {
      data = [];
    }
    data.push(newData);
  }
  removeAttribute(data, index) {
    data.splice(index, 1);
  }
  import() {
    const result = this.parseJson(this.rawBody, this.devexTesterDataService.rawDataKeyTypes);
    Object.assign(this.bodyParams, result);
  }

  getDataType(value, dataTypeFilter) {
    // const dataType = dataTypeFilter.find((item) => item.value === typeof value);
    // return dataType ? dataType.value : typeof value;

    if (value) {
      if (typeof value === 'string') {
        const stringType = dataTypeFilter.find((item) => item.value.toLowerCase() === 'string');
        return stringType ? stringType.value : 'Unknown';
      } else if (typeof value === 'boolean') {
        const booleanType = dataTypeFilter.find((item) => item.value.toLowerCase() === 'boolean');
        return booleanType ? booleanType.value : 'Unknown';
      } else if (typeof value === 'number') {
        if (Number.isInteger(value)) {
          const integerType = dataTypeFilter.find((item) => item.value.toLowerCase() === 'integer');
          return integerType ? integerType.value : 'Unknown';
        } else if (Number.isFinite(value) && Math.floor(value) === value) {
          const longType = dataTypeFilter.find((item) => item.value.toLowerCase() === 'long');
          return longType ? longType.value : 'Unknown';
        } else if (!Number.isNaN(value)) {
          const floatType = dataTypeFilter.find((item) => item.value.toLowerCase() === 'float');
          return floatType ? floatType.value : 'Unknown';
        } else {
          return 'Unknown';
        }
      } else if (Array.isArray(value)) {
        return 'Array';
      } else if (typeof value === 'object') {
        return 'Object';
      } else {
        return 'Object';
      }
    } else {
      return null;
    }
  }
  parseJson(inputJson, dataTypeFilter) {
    const result = [];
    for (const key in inputJson) {
      if (inputJson.hasOwnProperty(key)) {
        const value = inputJson[key];
        const dataType = this.getDataType(value, dataTypeFilter);
        const description = ''; // You can set the description here.

        if (Array.isArray(value)) {
          let subType = [];
          if (value.length) {
            subType = this.parseJson(value[0], dataTypeFilter);
          }
          let type = 'Object';
          if (value.length) {
            // Check the type of the first element in the array
            type = this.getDataType(value[0], dataTypeFilter);
          }
          result.push({
            key,
            type: type,
            subType: subType,
            req: true, // You can set this based on your logic.
            array: true,
            description,
            value: value.length > 0 ? (type !== 'Object' ? JSON.stringify(value) : null ): null, // Convert the array to a string
          });
        } else if (typeof value === 'object') {
          const subType = this.parseJson(value, dataTypeFilter);
          result.push({
            key,
            type: 'Object',
            subType: subType,
            req: true, // You can set this based on your logic.
            array: false,
            description,
            value: null,
          });
        } else {
          result.push({
            key,
            type: dataType,
            req: true, // You can set this based on your logic.
            array: false,
            description,
            value,
          });
        }
      }
    }
    return result;
  }

  importAndMerge() {
    const result = this.parseJson(this.rawBody, this.devexTesterDataService.rawDataKeyTypes);

    // Merge the old data with new data
    for (const newItem of result) {
      const existingItem = this.bodyParams.find(item => item.key === newItem.key);

      if (existingItem) {
        // Preserve the description if it exists
        if (existingItem.description) {
          newItem.description = existingItem.description;
        }

        // Update the existing item with the new data
        if (newItem.subType && existingItem.subType) {
          // Merge subtypes recursively
          newItem.subType = this.mergeSubTypes(existingItem.subType, newItem.subType);
        }

        Object.assign(existingItem, newItem);
      } else {
        // Add the new item to the old data
        this.bodyParams.push(newItem);
      }
    }

    // Remove keys that are not in the new data
    this.bodyParams = this.bodyParams.filter(item => result.some(newItem => newItem.key === item.key));

    return this.bodyParams;
  }

  mergeSubTypes(existingSubType, newSubType) {
    for (const newSubTypeItem of newSubType) {
      const existingSubTypeItem = existingSubType.find(item => item.key === newSubTypeItem.key);

      if (existingSubTypeItem) {
        // Preserve the description if it exists
        if (existingSubTypeItem.description) {
          newSubTypeItem.description = existingSubTypeItem.description;
        }

        if (newSubTypeItem.subType && existingSubTypeItem.subType) {
          // Merge nested subtypes recursively
          newSubTypeItem.subType = this.mergeSubTypes(existingSubTypeItem.subType, newSubTypeItem.subType);
        }

        Object.assign(existingSubTypeItem, newSubTypeItem);
      } else {
        existingSubType.push(newSubTypeItem);
      }
    }

    return existingSubType;
  }


  changedType(data) {
    if (data.type === 'Object') {
      if (!data.subType) {
        data.subType = [];
      }
      this.addAttributeField(data.subType);
    }
  }
}
